import React, { useContext } from 'react';
import { LoginContext } from '../../../context/loginContext.js';
import { Image } from 'antd';
import 'chart.js/auto';

const CHomeAdministrador = () => {
  const { user, logout } = useContext(LoginContext);
  const { selectedEmpresa } = useContext(LoginContext);
  console.log(selectedEmpresa);

  return (
<div
      style={{
        height: 'calc(80vh - 20px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        margin: '0',
      }}
    >
      <Image
        src="/logo-geno-gris.png"
        alt="Logo"
        preview={false}
        style={{ width: '50%', height: 'auto' }}
      />
    </div>
  );
};

export default CHomeAdministrador;